
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import 'react';
import Text from '../Text/Text.js';
import { container } from './styles.js';
import { createElement as jsx } from '../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var _excluded = ["percent", "size", "color", "rounded", "labelBefore", "labelAfter"];
var ProgressBar = function ProgressBar(_ref) {
  var percent = _ref.percent,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "md" : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "success" : _ref$color,
    _ref$rounded = _ref.rounded,
    rounded = _ref$rounded === void 0 ? true : _ref$rounded,
    labelBefore = _ref.labelBefore,
    labelAfter = _ref.labelAfter,
    rest = _objectWithoutProperties(_ref, _excluded);
  var showPercentage = percent >= 0 && percent <= 100 && size !== "sm" && size !== "xs";
  return jsx("div", _extends({
    css: function css(theme) {
      return container(theme, {
        percent: percent,
        showPercentage: showPercentage,
        size: size,
        rounded: rounded,
        color: color
      });
    }
  }, rest), labelBefore && jsx(Text, {
    fontSize: "xs",
    weight: "400",
    className: "label"
  }, labelBefore), jsx("div", {
    className: "percentage-container"
  }, showPercentage && jsx("div", {
    "data-testid": "percentage",
    dangerouslySetInnerHTML: {
      __html: "".concat(percent, "&rlm;%")
    }
  })), labelAfter && jsx(Text, {
    fontSize: "xs",
    weight: "400",
    className: "label"
  }, labelAfter));
};

export { ProgressBar as default };
//# sourceMappingURL=ProgressBar.js.map
